import i18n from '../i18n';

/**
 * Format message info time (for message info modal)
 * @param {Date|string} date - Date to format
 * @returns {string} Formatted string:
 *   - "Today HH:MM" if today
 *   - "Yesterday HH:MM" if yesterday
 *   - "DD.MM.YYYY" if older
 */
export const formatMessageInfo = (date) => {
  if (!date) return '';
  
  try {
    const now = new Date();
    const target = new Date(date);
    
    // Check if date is valid
    if (!target || isNaN(target.getTime())) {
      return '';
    }

    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const targetDate = new Date(
      target.getFullYear(),
      target.getMonth(),
      target.getDate()
    );

    const time = target.toLocaleTimeString(i18n.language, {
      hour: '2-digit',
      minute: '2-digit'
    });

    if (targetDate.getTime() === today.getTime()) {
      return i18n.t('shared:messageInfo.today', { time });
    }

    if (targetDate.getTime() === yesterday.getTime()) {
      return i18n.t('shared:messageInfo.yesterday', { time });
    }

    return target.toLocaleDateString(i18n.language);
  } catch (error) {
    // Silently fail
    return '';
  }
};

